import { i18n } from '@/commons/utils';

import {
  showStockNotificationInvite,
  hideStockNotificationInvite,
} from './stock-notification';

import { domRemoveStoreResults } from './pdp-store_selection-utils';
import {
  resetTab as resetCncTab,
  updateTab as updateCncTab,
} from './click-n-collect-tabs';

const displayButtons = (display = false) => {
  const addToCartButton = cube.$id('ctaButton');
  const addExpressButton = cube.$id('express-payment-cta');

  if (addToCartButton) {
    if (!display) {
      addToCartButton.classList.add('disabled');
      addToCartButton.classList.add('cta-v2--disabled');
      addToCartButton.disabled = true;
      if (addExpressButton) {
        addExpressButton.classList.add('disabled');
        addExpressButton.classList.add('cta-v2--disabled');
        addExpressButton.disabled = true;
      }
    } else {
      addToCartButton.classList.remove('disabled');
      addToCartButton.classList.remove('cta-v2--disabled');
      addToCartButton.disabled = false;
      if (addExpressButton) {
        addExpressButton.classList.remove('disabled');
        addExpressButton.classList.remove('cta-v2--disabled');
        addExpressButton.disabled = false;
      }
    }
  }
};

// ---

const ctaUpdates = skuParams => {
  const { modelId, scope } = skuParams;

  const skuSelector =
    modelId && scope.$(`.sizes__wrapper[data-id="${modelId}"]`);

  if (
    skuSelector &&
    skuSelector.dataset.sellableonline === 'true' &&
    skuSelector.$('.sizes__size--selected') &&
    skuSelector.$('.sizes__size--selected').dataset.quantity === 'true'
  )
    displayButtons(true);

  // Exception to logical behavior: if no size is selected we must display the button as enabled
  else if (
    scope.$('.sizes__wrapper--visible .sizes__button') && scope.$('.sizes__wrapper--visible .sizes__button').textContent ===
    i18n('pdm.size')
  )
    displayButtons(true);

  else displayButtons(false);
};

const resetStorePanelResults = () => {
  if (cube.$('#store-selection-panel'))
    cube
      .$$('#store-selection-panel .store-selection__result-list')
      .forEach(domRemoveStoreResults);
};

const updateFavoriteStoreStockDisplay = sku => {
  const favStoreStockQuantity = cube.$('.js-favorite-store-stocks__message');

  if (sku) {
    let alertInStockInFavStore = `<span class="icon icon-ok-roll"></span><i class="info-green">${i18n(
      'pdm.instore.stock.alert.instock'
    )}</i>`;
    const alertFewStockInFavStore = `<span class="icon icon-alert-roll orange"></span><i class="info-orange">${i18n(
      'pdm.instore.stock.alert.few'
    )}</i>`;
    const alertOutStockInFavStore = `<span class="icon icon-alert-roll"></span><i class="info-red">${i18n(
      'pdm.instore.stock.alert.outstock'
    )}</i>`;
    const userHasFavoriteStore = cube.$('.js-favorite-store');

    // If user has a favorite store & cnc1h is desactivated, show said-store stock
    if (userHasFavoriteStore && favStoreStockQuantity) {
      favStoreStockQuantity.textContent = '';

      if (sku.dataset.favstoreStock === '0')
        favStoreStockQuantity.insertAdjacentHTML(
          'afterbegin',
          alertOutStockInFavStore
        );
      else if (sku.dataset.favstoreAboveThreshold === 'false')
        favStoreStockQuantity.insertAdjacentHTML(
          'afterbegin',
          alertFewStockInFavStore
        );
      else {
        alertInStockInFavStore = `<span class="icon icon-ok-roll"></span><i class="info-green">${i18n(
          'pdm.instore.stock.alert.instock',
          sku.dataset.favstoreStock
        )}</i>`;
        favStoreStockQuantity.insertAdjacentHTML(
          'afterbegin',
          alertInStockInFavStore
        );
      }
    }
  } else if (favStoreStockQuantity) favStoreStockQuantity.textContent = '';
};

const stockQuantityDisplay = eventParams => {
  const { sku, model, scope } = eventParams;

  const stockQuantityDisplayer = scope.$('.sizes__stock-quantity') || null;

  const alertInStockOnline = `<span class="icon icon-ok-roll"></span><i ${cube.tnr.setDataTnr(
    ['stock-level', 'in-stock']
  )} class="info-green">${i18n('pdm.online.stock.alert.instock')}</i>`;
  const alertFewStockOnline = `<span class="icon icon-alert-roll orange"></span><i ${cube.tnr.setDataTnr(
    ['stock-level', 'few-in-stock']
  )} class="info-orange">${i18n('pdm.online.stock.alert.few')}</i>`;
  const alertOutStockOnline = `<span class="icon icon-alert-roll"></span><i ${cube.tnr.setDataTnr(
    ['stock-level', 'out-of-stock']
  )} class="info-red">${i18n('pdm.online.stock.alert.outstock')}</i>`;
  const alertNonSellableOnline = `<span class="icon icon-alert-roll"></span><i ${cube.tnr.setDataTnr(
    ['stock-level', 'out-of-stock']
  )} data-tnr-not-available-online class="info-red">${i18n(
    'product.store.onlyAvailableInStore'
  )}</i>`;

  if (stockQuantityDisplayer) {
    stockQuantityDisplayer.textContent = '';

    if (sku) {
      const { belowthreshold, quantity } = sku.dataset;
      const { sellableonline } = model.dataset;

      if (sellableonline === 'false')
        stockQuantityDisplayer.insertAdjacentHTML(
          'afterbegin',
          alertNonSellableOnline
        );
      else if (quantity === 'false')
        stockQuantityDisplayer.insertAdjacentHTML(
          'afterbegin',
          alertOutStockOnline
        );
      else if (belowthreshold === 'true')
        stockQuantityDisplayer.insertAdjacentHTML(
          'afterbegin',
          alertFewStockOnline
        );
      else
        stockQuantityDisplayer.insertAdjacentHTML(
          'afterbegin',
          alertInStockOnline
        );
    }
  }
};

const updateLeadTime = (sku = null, model = null) => {
  if (cube.$('.leadtime-display__content') && cube.$('.leadtime-display')) {
    if (sku && sku.dataset.leadtime) {
      cube.$('.leadtime-display__content').innerHTML = sku.dataset.leadtime;
      cube.$('.leadtime-display').classList.add('leadtime-display--visible');
    } else if (model && model.dataset.leadtime) {
      cube.$('.leadtime-display__content').innerHTML = model.dataset.leadtime;
      cube.$('.leadtime-display').classList.add('leadtime-display--visible');
    } else
      cube.$('.leadtime-display').classList.remove('leadtime-display--visible');
  }
};

const updateBackInStockNotificationDisplay = (sku = null) => {
  if (cube.$('.stock-notification')) {
    if (sku) {
      const { quantity, backinstockqualified } = sku.dataset;

      // Display back-in-stock subscription invite for eligible skus
      if (backinstockqualified === 'true' && quantity === 'false')
        showStockNotificationInvite();
      else hideStockNotificationInvite();
    } else {
      hideStockNotificationInvite();
    }
  }
};

const storePriceManager = (sku = null, model = null) => {
  // Update to sku price
  if (sku && sku.dataset.id && cube.$id(`sku-price-${sku.dataset.id}`)) {
    cube.$id('current-price-container').innerHTML = cube.$id(
      `sku-price-${sku.dataset.id}`
    ).innerHTML;
  }

  // update to model price if there is no sku
  else if (
    model &&
    model.dataset.id &&
    cube.$id(`model-price-${model.dataset.id}`)
  )
    cube.$id('current-price-container').innerHTML = cube.$id(
      `model-price-${model.dataset.id}`
    ).innerHTML;
};


const handleCncDisplay = sku => {
  const cncIsEnabled = cube.$('.buying-zone--cnc1h');
  if (cncIsEnabled) {
    if (sku) {
      // show stock online zone & enable 'c&c in store' tab...
      cube.$('.buying-zone').classList.add('buying-zone--shows-online-stock');
      cube.$('.buying-zone__tab-input--store').disabled = false;
      // ...& update store tab
      updateCncTab(sku);
    } else resetCncTab();
  }
};

// ---

export const init = () => {
  cube.event.on('sizeChanged', eventParams => {
    const { skuId, modelId, scope } = eventParams;
    const sku = cube.$(`#conversion-zone [data-id="${skuId}"]`) || null;
    const model = cube.$(`#conversion-zone [data-id="${modelId}"]`) || null;

    eventParams.sku = sku;
    eventParams.model = model;

    if (scope && scope.id === 'conversion-zone') {
      ctaUpdates(eventParams);
      resetStorePanelResults();
      updateFavoriteStoreStockDisplay(sku);
      stockQuantityDisplay(eventParams);
      updateLeadTime(sku, model);
      updateBackInStockNotificationDisplay(sku);
      storePriceManager(sku, model);
      handleCncDisplay(sku);
    }
  });
};



// WEBPACK FOOTER //
// ./src/catalog/product-details/conversion-zone-updates.js